(() => {
  const running = new WeakMap();
  const closeTimers = new WeakMap();
  let panelId = 0;
  const isMobileMain = details => window.innerWidth < 750 && details.matches('.irriga-cross-menu__group > details') && Boolean(details.closest('.icb'));
  const configurePanel = details => {
    const panel = details.querySelector(':scope > ul');
    if (!panel) return;
    const usePopover = 'showPopover' in panel && (isMobileMain(details) || (details.matches('.irriga-cross-menu__subgroup') && window.innerWidth >= 750));
    if (panel.hasAttribute('popover') && !usePopover && panel.matches(':popover-open')) panel.hidePopover();
    panel.toggleAttribute('popover', usePopover);
    if (usePopover) panel.setAttribute('popover', 'manual');
    panel.id = `irriga-touch-panel-${++panelId}`;
    const toggle = details.querySelector(':scope > summary > [data-irriga-menu-toggle]');
    if (toggle) { toggle.setAttribute('aria-controls', panel.id); toggle.setAttribute('aria-expanded', String(details.open)); }
  };
  const positionPanel = (details) => {
    if (isMobileMain(details)) {
      const panel = details.querySelector(':scope > ul');
      const bounds = details.querySelector(':scope > summary').getBoundingClientRect();
      const width = Math.min(340, document.documentElement.clientWidth - 24);
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const below = viewportHeight - bounds.bottom - 12;
      const openAbove = below < 160 && bounds.top > below;
      const available = Math.max(80, openAbove ? bounds.top - 12 : below);
      panel.style.width = `${width}px`;
      panel.style.setProperty('--submenu-available-height', `${available}px`);
      panel.style.left = `${Math.max(12, Math.min(bounds.left + bounds.width / 2 - width / 2, document.documentElement.clientWidth - width - 12))}px`;
      panel.style.top = `${openAbove ? Math.max(12, bounds.top - Math.min(panel.scrollHeight, available)) : bounds.bottom}px`;
      return;
    }
    if (details.matches('.irriga-cross-menu__subgroup')) {
      const panel = details.querySelector(':scope > ul');
      if (window.innerWidth < 750) return;
      const bounds = details.parentElement.getBoundingClientRect();
      const viewportWidth = document.documentElement.clientWidth;
      const width = Math.min(280, Math.max(160, viewportWidth - 24));
      panel.style.setProperty('--subgroup-width', `${width}px`);
      const openLeft = viewportWidth - bounds.right < width && bounds.left >= width;
      details.toggleAttribute('data-open-left', openLeft);
      const top = Math.max(12, Math.min(bounds.top, window.innerHeight - panel.offsetHeight - 12));
      if (panel.hasAttribute('popover')) {
        const left = Math.max(12, Math.min(openLeft ? bounds.left - width : bounds.right, viewportWidth - width - 12));
        panel.style.left = `${left}px`;
        panel.style.top = `${top}px`;
      } else {
        panel.style.setProperty('--subgroup-top', `${top - bounds.top}px`);
      }
      return;
    }
    const isBar = Boolean(details.closest('.icb'));
    const isSide = Boolean(details.closest('.irriga-sticky-catalog__panel')) && window.innerWidth >= 750;
    if (!isBar && !isSide) return;
    const panel = details.querySelector(':scope > ul');
    if (!panel) return;
    const group = details.closest('.irriga-cross-menu__group');
    const bounds = group.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    if (isSide) {
      const available = viewportWidth - bounds.right - 12;
      details.toggleAttribute('data-flyout-below', available < 180);
      panel.style.setProperty('--flyout-width', `${Math.min(300, Math.max(180, available))}px`);
      panel.style.setProperty('--submenu-available-height', `${Math.max(100, window.innerHeight - 24)}px`);
      const height = panel.offsetHeight;
      const top = Math.min(0, Math.max(12, window.innerHeight - height - 12) - bounds.top);
      panel.style.setProperty('--flyout-top', `${top}px`);
      return;
    }
    const center = bounds.left + bounds.width / 2;
    const width = panel.offsetWidth;
    const left = Math.max(12, Math.min(center - width / 2, viewportWidth - width - 12));
    panel.style.setProperty('--submenu-shift', `${left + width / 2 - center}px`);
    panel.style.setProperty('--submenu-available-height', `${Math.max(80, window.innerHeight - bounds.bottom - 12)}px`);
  };
  const motion = (details, opening) => {
    const panel = details.querySelector(':scope > ul');
    if (!panel) return;
    const toggle = details.querySelector(':scope > summary > [data-irriga-menu-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', String(opening));
    if (details.matches('.irriga-cross-menu__subgroup')) {
      if (opening) {
        details.open = true;
        if (panel.hasAttribute('popover') && !panel.matches(':popover-open')) panel.showPopover();
        positionPanel(details);
      } else {
        if (panel.hasAttribute('popover') && panel.matches(':popover-open')) panel.hidePopover();
        details.open = false;
      }
      return;
    }
    if (!opening) details.querySelectorAll('details[open]').forEach(child => motion(child, false));
    const previous = running.get(details);
    const wasOpen = details.open;
    const isSide = Boolean(details.closest('.irriga-sticky-catalog__panel')) && window.innerWidth >= 750;
    const collapsed = isSide ? 'inset(0 100% 0 0)' : 'inset(0 0 100% 0)';
    const fromClip = wasOpen ? getComputedStyle(panel).clipPath : collapsed;
    if (previous) previous.cancel();
    running.delete(details);
    panel.inert = !opening;
    if (opening) { details.open = true; if (panel.hasAttribute('popover') && !panel.matches(':popover-open')) panel.showPopover(); positionPanel(details); }
    if (!opening && !wasOpen) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const duration = reduced ? 0 : parseFloat(getComputedStyle(details).getPropertyValue('--menu-duration')) || 220;
    if (!duration || !panel.animate) { details.open = opening; panel.inert = false; if (!opening && panel.hasAttribute('popover') && panel.matches(':popover-open')) panel.hidePopover(); return; }
    const animation = panel.animate([
      {clipPath:fromClip === 'none' ? 'inset(0 0 0 0)' : fromClip},
      {clipPath:opening ? 'inset(0 0 0 0)' : collapsed}
    ], {duration,easing:'cubic-bezier(.2,.7,.2,1)',fill:'both'});
    running.set(details,animation);
    animation.finished.then(() => {
      if (running.get(details) !== animation) return;
      details.open = opening;
      if (!opening && panel.hasAttribute('popover') && panel.matches(':popover-open')) panel.hidePopover();
      panel.inert = false;
      animation.cancel();
      running.delete(details);
    }).catch(() => {});
  };
  const attach = (root = document) => {
    root.querySelectorAll('.irriga-cross-menu__group > details, .irriga-cross-menu__subgroup').forEach(details => {
      configurePanel(details);
      if (details.dataset.hoverReady) return;
      details.dataset.hoverReady = 'true';
      const childPanel = details.querySelector(':scope > ul');
      if (details.matches('.irriga-cross-menu__subgroup') && childPanel && 'showPopover' in childPanel && window.innerWidth >= 750) {
        childPanel.setAttribute('popover', 'manual');
      }
      const cancelClose = () => {
        for (let node = details; node; node = node.parentElement.closest('details')) {
          clearTimeout(closeTimers.get(node));
        }
      };
      const enter = event => {
        if (event.pointerType === 'touch' || (window.innerWidth < 750 && event.type === 'mouseenter' && !window.matchMedia('(hover: hover)').matches)) return;
        cancelClose();
        details.parentElement.parentElement.querySelectorAll(':scope > li > details[open]').forEach(other => {
          if (other !== details) motion(other, false);
        });
        if (!details.open) motion(details, true);
        else positionPanel(details);
      };
      const leave = event => {
        if (event.pointerType === 'touch' || (window.innerWidth < 750 && event.type === 'mouseenter' && !window.matchMedia('(hover: hover)').matches)) return;
        clearTimeout(closeTimers.get(details));
        closeTimers.set(details, setTimeout(() => {
          const panel = details.querySelector(':scope > ul');
          if (!details.matches(':hover') && !panel.matches(':hover')) motion(details, false);
        }, 180));
      };
      // A real mouse can be present even when the primary device reports no hover.
      details.addEventListener('pointerenter', enter);
      details.addEventListener('mouseenter', enter);
      details.addEventListener('pointerleave', leave);
      details.addEventListener('mouseleave', leave);
      if (childPanel) {
        childPanel.addEventListener('pointerenter', cancelClose);
        childPanel.addEventListener('mouseenter', cancelClose);
      }
      details.addEventListener('focusin', event => {
        if (!event.target.closest('[data-irriga-menu-toggle]') && event.target !== details.querySelector('summary') && !details.open) motion(details,true);
      });
      details.addEventListener('focusout', event => { if (!details.contains(event.relatedTarget)) motion(details,false); });
      details.querySelector(':scope > summary').addEventListener('click', event => {
        event.stopPropagation();
        if (event.target.closest('a')) return;
        event.preventDefault();
        if (!details.open) details.parentElement.parentElement.querySelectorAll(':scope > li > details[open]').forEach(other => { if (other !== details) motion(other,false); });
        motion(details,!details.open);
      });
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); motion(details,false); details.querySelector('summary').focus(); event.stopPropagation(); }
      });
    });
  };
  const sync = () => {
    const source = document.querySelector('[data-irriga-menu-source]');
    const menu = source && source.querySelector('.irriga-cross-menu');
    if (menu) document.querySelectorAll('[data-irriga-menu-mirror]').forEach(target => {
      const clone = menu.cloneNode(true);
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
      clone.querySelectorAll('[data-hover-ready]').forEach(node => node.removeAttribute('data-hover-ready'));
      clone.querySelectorAll('details').forEach(node => { node.open = false; node.querySelector(':scope > ul').inert = false; });
      target.replaceChildren(clone);
      ['--submenu-bg','--submenu-text','--submenu-hover','--submenu-border','--submenu-border-width','--submenu-radius','--submenu-underline','--submenu-underline-width','--menu-zoom','--menu-duration'].forEach(prop => target.style.setProperty(prop, source.style.getPropertyValue(prop)));
    });
    if (source) document.querySelectorAll('.irriga-sticky-catalog__panel').forEach(panel => {
      ['--submenu-bg','--submenu-text','--submenu-hover','--submenu-border','--submenu-border-width','--submenu-radius'].forEach(prop => panel.style.setProperty(prop, source.style.getPropertyValue(prop)));
    });
    attach();
    document.querySelectorAll('.icb__scroll').forEach(scroller => {
      if (scroller.dataset.touchScrollReady) return;
      scroller.dataset.touchScrollReady = 'true';
      scroller.addEventListener('scroll', () => scroller.querySelectorAll('.irriga-cross-menu__group > details[open]').forEach(details => motion(details,false)), {passive:true});
    });
  };
  // Close floating bar menus on page scroll; scrolling within a submenu stays local.
  window.addEventListener('scroll', () => {
    document.querySelectorAll('.icb details[open]').forEach(details => motion(details, false));
  }, {passive:true});
  window.addEventListener('resize', () => {
    document.querySelectorAll('.irriga-cross-menu__group > details, .irriga-cross-menu__subgroup').forEach(details => {
      const panel = details.querySelector(':scope > ul');
      running.get(details)?.cancel(); running.delete(details);
      clearTimeout(closeTimers.get(details));
      if (panel.hasAttribute('popover') && panel.matches(':popover-open')) panel.hidePopover();
      details.open = false; panel.inert = false;
      ['left','top','width'].forEach(prop => panel.style.removeProperty(prop));
      configurePanel(details);
    });
  }, {passive:true});
  document.addEventListener('click', event => {
    if (event.target.closest('.icb .irriga-cross-menu__group')) return;
    document.querySelectorAll('.icb details[open]').forEach(details => motion(details, false));
  });
  sync();
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:reorder', sync);
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details') || event.target.querySelector('details');
    if (details) {
      const ancestors = [];
      for (let node = details; node; node = node.parentElement.closest('details')) ancestors.unshift(node);
      ancestors.forEach(node => motion(node,true));
    }
  });
})();
